import store from 'store';

// Reads the Caller V2 toggle from the shop-settings slice. Usable from imperative
// (non-React) code — the socket subscribe callback and the saga message handler —
// where hooks/selectors aren't available. Kept dependency-light (store only) to
// avoid import cycles with the CallerV2 panel.
export const isCallerV2Enabled = (): boolean =>
  !!store.getState().shop?.setting?.enableCallerV2;
